export const routes = [
    {
        name: 'Home',
        path: ['/'],
        page: 'home'
    },
    {
        name: 'Other_Page',
        path: ['/page'],
        page: 'otherPage'
    }
]